import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { ProductCategory, RidangoReduxAction } from '@ridango/core';

import { Observable } from 'rxjs';

import { ProductCategoriesActions } from './product-categories.actions';
import { ProductCategoriesPartialStoreState } from './product-categories.reducer';
import * as ProductCategoriesSelectors from './product-categories.selectors';
import { map } from 'rxjs/operators';

@Injectable()
export class ProductCategoriesFacade {
    loaded$ = this.store.select(ProductCategoriesSelectors.getLoaded);
    error$ = this.store.select(ProductCategoriesSelectors.getError);
    types$ = this.store.select(ProductCategoriesSelectors.getCategoryTypes);

    selectedCategoryIdByTypeObject$ = this.store.select(ProductCategoriesSelectors.getSelectedCategoryIdByTypeObject);
    defaultProductCategory$ = this.store
        .select(ProductCategoriesSelectors.getAllCategories)
        .pipe(map((v) => v.find((v) => v.type === 'product')));

    constructor(
        private store: NgRedux<ProductCategoriesPartialStoreState>,
        private actions: ProductCategoriesActions
    ) {}

    dispatch(action: RidangoReduxAction) {
        this.store.dispatch(action);
    }

    fetchCategories() {
        this.dispatch(this.actions.fetchProductCategories());
    }

    getCategoriesByType(type: string): Observable<ProductCategory[]> {
        return this.store.select(ProductCategoriesSelectors.getCategoriesByType.bind(null, type));
    }

    getSubCategories(categoryId: number): Observable<ProductCategory[]> {
        return this.store.select(ProductCategoriesSelectors.getSubCateories(categoryId));
    }

    setSelectedCategory(category: ProductCategory) {
        this.dispatch(this.actions.setSelectedCategoryByType(category));
    }

    getSelectedCategoryByType(type: string): Observable<ProductCategory> {
        return this.store.select(ProductCategoriesSelectors.getSelectedCategoryByType.bind(null, type));
    }

    setProductCategories(productCategoryIds: number[]): void {
        this.dispatch(this.actions.setProductCategories(productCategoryIds));
    }

    resetSelection() {
        this.dispatch(this.actions.resetCategorySelections());
    }
}
